// import Header from "../Header";
// import { AdminSidebarMenu } from "../sidebar/AdminSidebarMenu";
//
//
// const AdminHeader = () => {
//   return <Header name='管理者' sideBarMenu={<AdminSidebarMenu/>}/>
// };
// export default AdminHeader;

import ResponsiveHeader from "./ResponsiveHeader";
import { AdminSidebarMenu } from "../sidebar/AdminSidebarMenu";
import { LogoutModal } from "../LogoutModal";

const AdminHeader = () => {
    return (
        <ResponsiveHeader
            name={null}
            title="BLOCKs"
            navItems={[<LogoutModal key="logout" />]}
            sidebar={<AdminSidebarMenu />}
        />
    );
};

export default AdminHeader;